import { type ReactNode } from 'react';
import { type PartnerTreeNodeV2 } from '@sr/types';
import { InactiveStateProvider } from './useInactiveState';

type LocationPickerProviderProps = {
  children: ReactNode;
  locations: PartnerTreeNodeV2[];
  hideInactiveLocations: boolean;
  showInactiveToggle: boolean;
  onInactiveToggle?: (hideInactive: boolean) => void;
};

export const LocationPickerProvider = (props: LocationPickerProviderProps) => {
  return (
    <InactiveStateProvider
      locations={props.locations}
      showInactiveToggle={props.showInactiveToggle}
      hideInactiveLocations={props.hideInactiveLocations}
      onInactiveToggle={props.onInactiveToggle}
    >
      {props.children}
    </InactiveStateProvider>
  );
};
